import {useCallback, useContext, useEffect} from "react";
import { AppContext } from "./AppContext";
import "./SyncStatus.css";

import IconCheck from './assets/check.svg';

const icons = {
  exporting: null,
  uploading: null,
  updatingMetafields: null,
  nothingToDo: IconCheck

}

function pluralize(count, noun, suffix = 's') {
  return `${count} ${noun}${count !== 1 ? suffix : ''}`;
}

function LatSyncStatus(props) {
  if (props.uploadResult) {
    const products = props.uploadResult.numberOfProducts
    const videos = props.uploadResult.numberOfUploadVideos
    const images = props.uploadResult.numberOfUploadImages
    let t = new Date(props.lastSync)
    if (products === 0) {
      return (
          <div className={"status-wrapper"}>
            <span>Media upload was attempted</span>
          </div>
      )
    } else {
      let line;
      if (videos >= 0 && images >= 0) {
        line = pluralize(images, 'image') + ' and ' + pluralize(videos, 'video');
      } else if (videos > 0 && images === 0) {
        line = pluralize(videos, 'video');
      } else if (images > 0 && videos === 0) {
        line = pluralize(images, 'image');
      }
      return (
          <div className={"status-wrapper"}>
            <div>At {t.toString()}, <br /> {line} of {pluralize(products, 'product')} were uploaded.</div>
            {props.syncErrors > 0 &&
                <div>Errors were encountered for media belonging to {props.syncErrors} products.</div>}
          </div>
      )
    }
  } else {
    return null
  }
}



export default function SyncStatus() {
  let { getBackendUrl, poll, setPoll, syncStatus, setSyncStatus, stages, cldStatus } =
    useContext(AppContext);

  async function getSyncErrors() {
    const res = await getBackendUrl("sync/get-errors");
    if (res && res.ok) {
      if (res.errors) {
        console.log(res.errors);
      }
    }
  }

  const getSyncStatus = useCallback( async () => {
    if (cldStatus) {
      const res = await getBackendUrl("sync/status");
      if (res && res.ok) {
        let text;
        if (res.status.syncStatus === "idle") {
          text = res.status.syncErrors === 0  ? "Media upload completed successfully" : "Some errors were encountered during media upload";
          setPoll(false);
        } else {
          text = stages[res.status.syncStatus] || "";
        }
        setSyncStatus({status: res.status.syncStatus, text: text, lastSync: res.status});
      }
    }
  }, [getBackendUrl, setSyncStatus, setPoll, stages, cldStatus]);

  useEffect(() => {
    if (poll) {
      const ticker = setInterval(getSyncStatus, 5000);
      return () => {
        clearInterval(ticker);
      };
    }
  }, [getSyncStatus, poll]);

  const working =
    syncStatus &&
    syncStatus.status !== "idle" &&
    syncStatus.status !== "nothingToDo";

  return (
    syncStatus !== null &&
    syncStatus !== "idle" && (
      <div className="component sync-status-component">
        <div className={"sync-status-wrap"}>
          {icons[syncStatus.status] && (
            <img className={"sync-status-icon"} src={icons[syncStatus.status]} alt="" />
          )}
          <div className={"sync-status-text"}>
            <div className={"sync-status"}>{syncStatus.text}</div>
            {working && (
              <p className={"sync-info"}>This could take some time.</p>
            )}
            {!working && (
                <div className={"sync-info"}>{<LatSyncStatus {...syncStatus.lastSync} />}</div>
            )}
          </div>
        </div>
      </div>
    )
  );
}
